import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
var i = {
	12: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 12 12",
			fill: "none",
			...e,
			children: [/* @__PURE__ */ n("path", {
				d: "M6.00031 0.712494C8.92033 0.712652 11.2876 3.07981 11.2877 5.99985C11.2877 8.91996 8.92038 11.287 6.00031 11.2872C5.62467 11.2872 5.25808 11.2474 4.9046 11.1729C5.34157 10.9301 5.71084 10.5815 5.97906 10.1615C5.98604 10.1615 5.99332 10.1622 6.00031 10.1622C8.29906 10.162 10.1627 8.29864 10.1627 5.99985C10.1626 3.70113 8.29901 1.83765 6.00031 1.83749C3.70147 1.83749 1.8373 3.70103 1.83722 5.99985C1.83722 6.00664 1.83719 6.01357 1.83722 6.02036C1.41769 6.28839 1.06918 6.65768 0.826477 7.09409C0.752187 6.74104 0.712219 6.37499 0.712219 5.99985C0.712298 3.07971 3.08015 0.712494 6.00031 0.712494Z",
				fill: "#8F8B85"
			}), /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M3.45001 6.2247C4.73374 6.22486 5.77514 7.26571 5.77545 8.54941C5.77545 9.83337 4.73394 10.8747 3.45001 10.8748C2.16608 10.8747 1.12531 9.83337 1.12531 8.54941C1.12562 7.26571 2.16628 6.22486 3.45001 6.2247ZM2.25031 8.06161C1.98126 8.06161 1.76283 8.28044 1.76251 8.54941C1.76251 8.81865 1.98107 9.0372 2.25031 9.0372H4.65045C4.91949 9.03696 5.13751 8.8185 5.13751 8.54941C5.1372 8.28058 4.91929 8.06185 4.65045 8.06161H2.25031Z",
				fill: "#8F8B85"
			})]
		}),
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: [/* @__PURE__ */ n("path", {
				d: "M8.00037 0.950012C11.8937 0.950223 15.0501 4.10643 15.0502 7.99982C15.0502 11.8933 11.8938 15.0494 8.00037 15.0496C7.49952 15.0496 7.01073 14.9966 6.53943 14.8973C7.12205 14.5735 7.61441 14.1087 7.97205 13.5486C7.98135 13.5487 7.99105 13.5496 8.00037 13.5496C11.0654 13.5494 13.5502 11.0649 13.5502 7.99982C13.5501 4.93486 11.0653 2.45022 8.00037 2.45001C4.93525 2.45001 2.44969 4.93473 2.44958 7.99982C2.44958 8.00887 2.44954 8.01812 2.44958 8.02716C1.89021 8.38454 1.42553 8.87693 1.10193 9.4588C1.00287 8.98807 0.949585 8.50001 0.949585 7.99982C0.949691 4.1063 4.10682 0.950012 8.00037 0.950012Z",
				fill: "#8F8B85"
			}), /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4.59998 8.29962C6.31162 8.29983 7.70014 9.68764 7.70056 11.3992C7.70056 13.1112 6.31188 14.4996 4.59998 14.4998C2.88807 14.4996 1.50037 13.1112 1.50037 11.3992C1.50079 9.68764 2.88833 8.29983 4.59998 8.29962ZM3.00037 10.7488C2.64164 10.7488 2.3504 11.0406 2.34998 11.3992C2.34998 11.7582 2.64138 12.0496 3.00037 12.0496H6.20056C6.55928 12.0493 6.84998 11.758 6.84998 11.3992C6.84956 11.0408 6.55902 10.7492 6.20056 10.7488H3.00037Z",
				fill: "#8F8B85"
			})]
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 20 20",
			fill: "none",
			...e,
			children: [/* @__PURE__ */ n("path", {
				d: "M10.0005 1.1875C14.8672 1.18776 18.8126 5.13302 18.8127 9.99976C18.8127 14.8666 14.8673 18.8117 10.0005 18.812C9.37443 18.812 8.76344 18.7457 8.17432 18.6216C8.9026 18.2168 9.51805 17.6359 9.96509 16.9358C9.97672 16.9358 9.98884 16.937 10.0005 16.937C13.8317 16.9367 16.9377 13.8311 16.9377 9.99976C16.9376 6.16856 13.8317 3.06276 10.0005 3.0625C6.16909 3.0625 3.06214 6.16839 3.06201 9.99976C3.06201 10.0111 3.06196 10.0226 3.06201 10.0339C2.36279 10.4807 1.78194 11.0961 1.37744 11.8235C1.25362 11.2351 1.18701 10.625 1.18701 9.99976C1.18714 5.13286 5.13356 1.1875 10.0005 1.1875Z",
				fill: "#8F8B85"
			}), /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M5.75 10.3745C7.88955 10.3748 9.6252 12.1095 9.62573 14.249C9.62573 16.389 7.88988 18.1245 5.75 18.1248C3.61012 18.1245 1.87549 16.389 1.87549 14.249C1.87602 12.1095 3.61045 10.3748 5.75 10.3745ZM3.75049 13.436C3.30208 13.436 2.93803 13.8007 2.9375 14.249C2.9375 14.6978 3.30176 15.062 3.75049 15.062H7.75073C8.19913 15.0616 8.5625 14.6975 8.5625 14.249C8.56197 13.801 8.1988 13.4364 7.75073 13.436H3.75049Z",
				fill: "#8F8B85"
			})]
		}),
		width: 20,
		height: 20
	},
	24: {
		Artwork: (e) => /* @__PURE__ */ r(t, {
			viewBox: "0 0 24 24",
			fill: "none",
			...e,
			children: [/* @__PURE__ */ n("path", {
				d: "M12.0006 1.42499C17.8407 1.4253 22.5752 6.15961 22.5753 11.9997C22.5753 17.8399 17.8408 22.5741 12.0006 22.5744C11.2493 22.5744 10.5162 22.4948 9.8092 22.3459C10.6831 21.8602 11.4217 21.1631 11.9581 20.3229C11.9721 20.323 11.9866 20.3244 12.0006 20.3244C16.5981 20.3241 20.3253 16.5973 20.3253 11.9997C20.3252 7.40225 16.598 3.6753 12.0006 3.67499C7.40294 3.67499 3.6746 7.40206 3.67444 11.9997C3.67444 12.0133 3.67437 12.0271 3.67444 12.0407C2.83537 12.5768 2.13835 13.3154 1.65295 14.1882C1.50437 13.4821 1.42444 12.75 1.42444 11.9997C1.4246 6.15942 6.1603 1.42499 12.0006 1.42499Z",
				fill: "#8F8B85"
			}), /* @__PURE__ */ n("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.90002 12.4494C9.46749 12.4497 11.5503 14.5314 11.5509 17.0988C11.5509 19.6667 9.46788 21.7494 6.90002 21.7497C4.33217 21.7494 2.25061 19.6667 2.25061 17.0988C2.25124 14.5314 4.33256 12.4497 6.90002 12.4494ZM4.50061 16.1232C3.96252 16.1232 3.52566 16.5609 3.52502 17.0988C3.52502 17.6373 3.96213 18.0744 4.50061 18.0744H9.3009C9.83898 18.0739 10.275 17.637 10.275 17.0988C10.2744 16.5612 9.83859 16.1237 9.3009 16.1232H4.50061Z",
				fill: "#8F8B85"
			})]
		}),
		width: 24,
		height: 24
	}
}, a = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: i[t],
	...r
});
//#endregion
export { a as StatusBlockedByIcon };
